import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Uploads } from "../../services/uploads";
import { Globals } from "../../../globals";
import { HttpParams, HttpClient } from '@angular/common/http';
import * as firebase from 'firebase';
import { AngularFirestore } from 'angularfire2/firestore';
import { StockProviderListPage } from "../../stock/stock-provider-list/stock-provider-list";
import { ImportFinishPage } from "./import-finish/import-finish";
import { TranslateService } from '@ngx-translate/core';


/**
 * Component que a traves de un array de Allergens muestra su icona
 *
 * Paso a crear:
 * Poder escoger el tamaño del icono
 */

@Component({
  selector: 'page-import-excel',
  templateUrl: 'import-excel.html',
})
export class ImportExcelPage {
  type: string = '';
  loadingPopup: any;
  list_elements: any = [];
  preview_table: boolean = false;
  select_provider: boolean = false;
  private firestore: any;
  selectedProvider: string;
  provider: any;
  keyboard: boolean = true;
  provider_data: any;
  provider_search: any;
  show_list: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public uploadServices: Uploads,
    public globals: Globals,
    public http: HttpClient,
    public afs: AngularFirestore,
    public translate: TranslateService) {

    this.firestore = firebase.firestore();
    //Params
    this.type = this.navParams.get('type'); //Type to know if import Providers, Dishes, Products or Ingredients

    if (this.type == 'ingredient' || this.type == 'product' || this.type == 'expense') {
      this.getProvidersList(this.globals.restaurant_uid); //Get all providers for the select if Ingredients or Products
      this.selectProvider('0'); //First option for Ingredients and Products that select provider
    } else {
      this.select_provider = true;
    }
  }
  //Create file in firebase
  selectedFiles: FileList;
  xls_ref: any;
  excel_url: any;
  file_type: any;
  file_url: any = '';
  async selectFileXls(event) {
    const file = event.target.files.item(0);

    if (file.type.match('application/vnd.ms-excel.*') || file.type.match('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.*')) {
      this.selectedFiles = event.target.files;//File selected
      this.xls_ref = await this.uploadServices.uploadCompleteExcel(this.selectedFiles, 'xls') //Upload file to firbase storage
      this.file_type = file.type; //Type of the file
      this.file_url = this.xls_ref; //Name of the file
      event.target.value = '';
      this.checkExcel();

    } else {
      let toast = this.loadingCtrl.create({
        content: this.translate.instant('import-excel-formato-invalido'),
        duration: 3000,
      });
      event.target.value = '';
      toast.present();
    }
  }

  //Check if all fields are filled
  file_name: string;
  field_empty: boolean = false;
  measurement_correct: boolean = true;
  async checkExcel() {
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('type', this.file_type)
      .set('file_url', this.file_url)
      .set('lang', this.globals.restaurant.lang);
    if (this.type == 'provider') {
      this.http.post(this.globals.analytics_path + 'import/check_import_providers', params, {})
        .subscribe(async res => {
          this.list_elements = res['list_providers'];
          this.field_empty = res['field_empty'];
          this.file_name = res['file_name'];
          this.preview_table = true;
        });
    } else if (this.type == 'dish') {
      this.http.post(this.globals.analytics_path + 'import/check_import_dishes', params, {})
        .subscribe(async res => {
          this.list_elements = res['list_dishes'];
          this.field_empty = res['field_empty'];
          this.file_name = res['file_name'];
          this.preview_table = true;
        });
    } else if (this.type == 'ingredient') {
      this.http.post(this.globals.analytics_path + 'import/check_import_ingredients', params, {})
        .subscribe(async res => {
          this.list_elements = res['list_ingredients'];
          this.field_empty = res['field_empty'];
          this.file_name = res['file_name'];
          this.measurement_correct = res['measurement_correct'];
          this.preview_table = true;
        });
    } else if (this.type == 'product') {
      this.http.post(this.globals.analytics_path + 'import/check_import_products', params, {})
        .subscribe(async res => {
          this.list_elements = res['list_products'];
          this.field_empty = res['field_empty'];
          this.file_name = res['file_name'];
          this.preview_table = true;
        });
    } else if (this.type == 'income') {
      this.http.post(this.globals.analytics_path + 'import/check_import_incomes', params, {})
        .subscribe(async res => {
          this.list_elements = res['list_incomes'];
          this.field_empty = res['field_empty'];
          this.file_name = res['file_name'];
          this.preview_table = true;
        });
    } else if (this.type == 'expense') {
      this.http.post(this.globals.analytics_path + 'import/check_import_expenses', params, {})
        .subscribe(async res => {
          this.list_elements = res['list_expenses'];
          this.field_empty = res['field_empty'];
          this.file_name = res['file_name'];
          this.preview_table = true;
        });
    } else if (this.type == 'customer') {
      this.http.post(this.globals.analytics_path + 'import/check_import_customers', params, {})
        .subscribe(async res => {
          this.list_elements = res['list_customers'];
          this.field_empty = res['field_empty'];
          this.file_name = res['file_name'];
          this.preview_table = true;
        });
    }

  }
  downloadExample() {
    //Download the example file
    if (this.type == 'provider') {
      window.location.href = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/templates_files%2Fplantilla_providers.xls?alt=media&token=c8be78d3-8166-48e7-9222-c0c4931b4ef4';
    } else if (this.type == 'dish') {
      window.location.href = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/templates_files%2Fplantilla_dishes.xls?alt=media&token=b0484716-0b64-441d-9a52-d47004d59a62';
    } else if (this.type == 'ingredient') {
      window.location.href = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/templates_files%2Fplantilla_ingredients.xls?alt=media&token=6d9ac05e-97e6-4d5d-b1bf-688493dd4600';
    } else if (this.type == 'product') {
      window.location.href = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/templates_files%2Fplantilla_products.xls?alt=media&token=dfe09fe6-76fb-4e20-a5a4-ac562b04455d';
    } else if (this.type == 'income') {
      window.location.href = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/templates_files%2Fplantilla_incomes.xls?alt=media&token=16c4a808-7af0-4139-ab5f-35e26bfe7d1c';
    } else if (this.type == 'expense') {
      window.location.href = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/templates_files%2Fplantilla_expenses.xls?alt=media&token=af7853fd-3571-4ec1-99da-4b222b538c33';
    } else if (this.type == 'customer') {
      window.location.href = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/templates_files%2Fplantilla_clientes.xls?alt=media&token=3e963dfd-7329-464a-8ec0-05d9cd03cb38';
    }
  }
  selectProvider(value) {
    //Value of the select
    this.selectedProvider = value;
    if (this.selectedProvider != '0') {
      this.select_provider = true;
      this.getProvider(this.selectedProvider);
    } else {
      this.select_provider = false;
    }
  }
  import() {
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('file_name', this.file_name);
    if (this.type == 'provider') {
      this.http.post(this.globals.analytics_path + 'import/import_providers', params, {})
        .subscribe(async res => {
          this.navCtrl.push(ImportFinishPage, {
            type: this.type
          });
        });
    } else if (this.type == 'dish') {
      this.http.post(this.globals.analytics_path + 'import/import_dishes', params, {})
        .subscribe(async res => {
          this.navCtrl.push(ImportFinishPage, {
            type: this.type
          });
        });
    } else if (this.type == 'ingredient') {
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('file_name', this.file_name)
        .set('provider', JSON.stringify(this.provider));
      this.http.post(this.globals.analytics_path + 'import/import_ingredients', params, {})
        .subscribe(async res => {
          this.navCtrl.push(ImportFinishPage, {
            type: this.type
          });
        });
    } else if (this.type == 'product') {
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('file_name', this.file_name)
        .set('provider', JSON.stringify(this.provider));
      this.http.post(this.globals.analytics_path + 'import/import_products', params, {})
        .subscribe(async res => {
          this.navCtrl.push(ImportFinishPage, {
            type: this.type
          });
        });
    } else if (this.type == 'income') {
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('file_name', this.file_name);
      this.http.post(this.globals.analytics_path + 'import/import_incomes', params, {})
        .subscribe(async res => {
          this.navCtrl.push(ImportFinishPage, {
            type: this.type
          });
        });
    } else if (this.type == 'expense') {
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('file_name', this.file_name)
        .set('provider', JSON.stringify(this.provider));
      this.http.post(this.globals.analytics_path + 'import/import_expenses', params, {})
        .subscribe(async res => {
          this.navCtrl.push(ImportFinishPage, {
            type: this.type
          });
        });
    } else if (this.type == 'customer') {
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('file_name', this.file_name)
        .set('provider', JSON.stringify(this.provider));
      this.http.post(this.globals.analytics_path + 'import/import_customers', params, {})
        .subscribe(async res => {
          this.navCtrl.push(ImportFinishPage, {
            type: this.type
          });
        });
    }
  }

  providersCol: any;
  providers_list: any = [];
  async getProvidersList(UID_RESTAURANT) {

    let limit = this.globals.checkLimitsByLicense('stock', 'providers');

    //miramos si la versión tiene un límite de proveedores
    if (limit == -1) {
      //si no, devolvemos todos los proveedores
      await this.firestore.collection('providers').where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('no_provider', 'desc').orderBy('name', 'asc').get().then(snapshot => {
        snapshot.forEach(doc => {
          var _data = doc.data();
          _data.UID = doc.id;
          this.providers_list.push(_data);
          this.providers_list.sort((one, two) => (one.name.toLowerCase() < two.name.toLowerCase() ? -1 : 1));
        });
      });
    } else {
      //Si tiene límite, buscamos por query él sin proveedor y los otros x primeros proveedores
      await this.firestore.collection('providers').where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('no_provider', 'desc').orderBy('name', 'asc').limit(limit + 1).get().then(snapshot => {
        snapshot.forEach(doc => {
          var _data = doc.data();
          _data.UID = doc.id;
          this.providers_list.push(_data);
          this.providers_list.sort((one, two) => (one.name.toLowerCase() < two.name.toLowerCase() ? -1 : 1));
        });
      });
    }

  }

  async getProvider(UID_PROVIDER) {
    const restRef = this.firestore.collection('providers').doc(UID_PROVIDER);
    await restRef.get().then(doc => {
      this.provider = doc.data();
      this.provider.UID = doc.id;
    });
  }

  goToProvider() {
    this.navCtrl.push(StockProviderListPage);
  }

  async searchProvider() {
    if (this.provider_data != undefined) {
      //Buscamos en el array de providers si hay algun elemento que coincida con el input
      //Añadimos todos los nombres de providers que contengan el input
      this.provider_search = this.providers_list.filter(item => item.name.toLowerCase().indexOf(this.provider_data.toLowerCase()) !== -1);
      //Eliminamos los elementos duplicados mirando UID
      this.provider_search = this.removeDuplicates(this.provider_search, 'UID');
      //Si el input tiene 2 o más caracteres mostramos la lista
      if (this.provider_data.length >= 2) {
        this.show_list = true;
      } else {
        this.show_list = false;
      }
    }
  }

  removeDuplicates(array, key) {
    let lookup = {};
    array.forEach(element => {
      lookup[element[key]] = element
    });
    return Object.keys(lookup).map(key => lookup[key]);
  }

  selectProviderSearch(provider) {
    this.provider_data = provider.name;
    this.show_list = false;
    this.selectProvider(provider.UID);
  }

  showList() {
    this.show_list = false;
    if (this.keyboard) {
      this.keyboard = false;
    } else {
      this.keyboard = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/import-excel/import-excel.ts